import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL, PRICE } from '../data/product';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const offer = document.getElementById('offer');
      const final = document.getElementById('final');
      const inView = (el: HTMLElement | null) => {
        if (!el) return false;
        const r = el.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      };
      setVisible(window.scrollY > 760 && !inView(offer) && !inView(final));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-216" data-mp="c5xv5g34ghqi">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-night/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-217" data-mp="c4w7mc4x62rw">
          <div className="flex items-center justify-between gap-3" data-id="element-218" data-mp="24ycn8clk9by">
            <div data-id="element-219" data-mp="gx9ze74f0tdg">
              <p className="font-display text-xl font-extrabold leading-none text-cream" data-id="element-220" data-mp="gxrydbigplp2">{PRICE}</p>
              <p className="mt-1 text-[11px] text-muted" data-id="element-221" data-mp="c35ojcs14173">Instant digital access</p>
            </div>
            <a href={CHECKOUT_URL} className="inline-flex h-12 items-center whitespace-nowrap rounded-xl bg-pumpkin px-5 font-display text-sm font-extrabold uppercase tracking-wide text-ink transition-[background-color,transform] duration-150 ease-out active:scale-[0.98]" data-id="element-222" data-mp="py83epeut0w1">
              Get It Now
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}